import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router';

import LoginPage from './pages/LoginPage/LoginPage';

const PrivateRoute = ({ component: Component, page, exact, location, authenticated, onIsAuthenticatedCallback, ...rest }) => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, [location.pathname]);

	if (authenticated.pending) {
		return null;
	}

	return (
		<Route
			exact={exact}
			{...rest}
			render={props =>
				authenticated.auth ? (
					<Component {...props} />
				) : (
					<LoginPage authenticated={false} onIsAuthenticatedCallback={onIsAuthenticatedCallback} />
				)
			}
		/>
	);
};

PrivateRoute.propTypes = {
	authenticated: PropTypes.shape({
		pending: PropTypes.bool,
		auth: PropTypes.bool
	}).isRequired,
	location: PropTypes.shape({
		pathname: PropTypes.string
	}),
	component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
	page: PropTypes.string,
	exact: PropTypes.bool,
	onIsAuthenticatedCallback: PropTypes.func
};

export default PrivateRoute;
